import React, { useRef } from 'react';
import { NavLink } from 'react-router-dom';

const TopHeader = () => {
  const navLinkClass = ({ isActive }) => (isActive ? "nav-link active" : "nav-link");
  const dropdownLinkClass = ({ isActive }) => (isActive ? "dropdown-item active" : "dropdown-item");
  const navMenuRef = useRef(null);

  const closeNavMenu = () => {
    if (navMenuRef.current) {
      navMenuRef.current.classList.remove('show');
    }
  };

  return (
    <>
      <section className="top-section-hear mobileview-header">
        <div className="wrapper">
          <nav className="navbar navbar-expand-lg navbar-dark px-4 p-0 fixed-top">
            <div className="container" style={{ maxWidth: "1600px" }}>
              <NavLink className="navbar-brand fw-bold" to="/">
                <img
                  src="./assets/images/BHAGESHWER-DHAAM_LOGO-300x169.png"
                  height="80"
                  width="150"
                  alt="Bageshwar Dham"
                  title=""
                  style={{ maxHeight: "88px" }}
                />
              </NavLink>
           
                    {/* <NavLink className="donation-mobile-view" to="https://ticket.sanskargroup.in/event/18" onClick={closeNavMenu}>
                 <img className="img-fluid"
        src='./assets/images/free_book.png'
        alt="Bageshwar Dham"
        title="Bageshwar Dham"  style={{ width: "80px" }}/>
                    </NavLink> */}
                
             <NavLink className="btn btn-start donate-top donation-mobile-view" to="/donate" onClick={closeNavMenu}>
                   🙏 Donate
                  </NavLink>

              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navMenu"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navMenu" ref={navMenuRef}>
                <ul className="navbar-nav me-auto mb-2 mb-lg-0 gap-3">
                  <li>
                    <NavLink className={navLinkClass} to="/" end onClick={closeNavMenu}>
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className={navLinkClass} to="/about" onClick={closeNavMenu}>
                      About Us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className={navLinkClass} to="/commingevent" onClick={closeNavMenu}>
                      Events
                    </NavLink>
                  </li>
                  <li className="nav-item dropdown">
                    <button
                      className="nav-link dropdown-toggle btn btn-link"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                     Our Sankalp
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="programsDropdown">
                      <li>
                        <NavLink className={dropdownLinkClass} to="/kanyavivah" onClick={closeNavMenu}>
                          Kanya Vivah
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className={dropdownLinkClass} to="/cancerhospital" onClick={closeNavMenu}>
                          Cancer Hospital
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className={dropdownLinkClass} to="/guaraksha" onClick={closeNavMenu}>
                          Gua Raksha
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className={dropdownLinkClass} to="/vedicgurukul" onClick={closeNavMenu}>
                          Vedic Gurukul
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className={dropdownLinkClass} to="/annapurnarasoi" onClick={closeNavMenu}>
                          Annapurna Rasoi
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                   <li>
                    <NavLink className={navLinkClass} to="/visitdham" onClick={closeNavMenu}>
                      Visit Dham
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className={navLinkClass} to="/contactus" onClick={closeNavMenu}>
                      Contact
                    </NavLink>
                  </li>
                   {/* <li>
                    <NavLink className={navLinkClass} to="https://ticket.sanskargroup.in/event/18" onClick={closeNavMenu}>
                 <img className="img-fluid"
        src='./assets/images/free_book.png'
        alt="Bageshwar Dham"
        title="Bageshwar Dham"  style={{ width: "120px" }}/>
                    </NavLink>
                  </li> */}
                </ul>

                <div className="d-flex align-items-center gap-3">
                   <NavLink className="btn btn-start status-indicator" to="https://www.youtube.com/c/BageshwarDhamSarkar" onClick={closeNavMenu}>
                    <span class="status-dot-container">
                    <span class="ping-animation"></span>
                    <span class="status-dot"></span>
                </span> Live
                  </NavLink>
                  {/* <div id="google_translate_element"></div> */}
                  <NavLink className="btn btn-start donate-top" to="/donate" onClick={closeNavMenu}>
                   🙏 Donate
                  </NavLink>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </section>
    </>
  );
};

export default TopHeader;
